<template>
  <!-- 红宝书融合课程-->
  <div class="shehuigongnengkaifake">
    <CertQuery :logo="Logo17" :type="'hbs-b'" :color="'#294db0'" />
  </div>
</template>

<script>
import CertQuery from '../component/certQuery.vue'
import Logo17 from '@/assets/images/logo17.jpg'

export default {
  name: 'SheHuiGongNengKaiFa',
  components: {
    CertQuery
  },
  data() {
    return {
      Logo17
    }
  }
}
</script>